module.exports = __webpack_public_path__ + "static/media/disagree.a37f9343.png";